import React from 'react';
import { Grid, Typography } from '@material-ui/core';

const ListHeader = () => (
    <Grid
        direction="row"
        container
        flex
        spacing={1}
    >
        <Grid
            item
            xs={5}
        >
            <Typography variant="h5">Label</Typography>
        </Grid>

        <Grid
            item
            xs={3}
        >
            <Typography variant="h5">Value</Typography>
        </Grid>
        <Grid
            item
            xs={2}
            align={'center'}
        >
            {/*<Typography variant="h5">Default</Typography>*/}
        </Grid>
    </Grid>
);

export default ListHeader;
